import { CommonEnums } from 'src/app/shared/common.enums';

export class Input_Inst {
    input_Inst_Id: number;
    dxMp_Id: number;
    nm: string;
    description: string;
    ver: string;
    valid_Cd: string;
    persistFlg: string;
    updateBy: string;
    lastUpdateBy: string;
    updateDt: Date;
    attr_Tab_Valid_Cd: string;

    constructor() {
        this.setDefaults()
    }

    static parse(input_InstTmp: Input_Inst): Input_Inst {
        let input_Inst: Input_Inst = new Input_Inst();
        input_Inst.copyFrom(input_InstTmp);
        return input_Inst;
    }

    setDefaults(): void {
        this.input_Inst_Id = CommonEnums.defaults.LONG_VAL;
        this.dxMp_Id = CommonEnums.defaults.LONG_VAL;
        this.nm = CommonEnums.defaults.STRING_EMPTY;
        this.description = CommonEnums.defaults.STRING_EMPTY;
        this.ver = CommonEnums.defaults.STRING_EMPTY;
        this.valid_Cd = CommonEnums.defaults.SUCCESS_CODE;
        this.persistFlg = CommonEnums.defaults.STRING_VAL_NO;
        this.updateBy = CommonEnums.defaults.STRING_EMPTY;
        this.lastUpdateBy = CommonEnums.defaults.STRING_EMPTY;
        this.updateDt = new Date;
        this.attr_Tab_Valid_Cd = CommonEnums.defaults.SUCCESS_CODE;
    }

    getPrimaryKey(): string {
        return this.input_Inst_Id+'.'+this.dxMp_Id;
    }

    copy(): Input_Inst {
        let input_InstTmp: Input_Inst = new Input_Inst();

        input_InstTmp.input_Inst_Id = this.input_Inst_Id;
        input_InstTmp.dxMp_Id = this.dxMp_Id;
        input_InstTmp.nm = this.nm;
        input_InstTmp.description = this.description;
        input_InstTmp.ver = this.ver;
        input_InstTmp.valid_Cd = this.valid_Cd;
        input_InstTmp.persistFlg = this.persistFlg;
        input_InstTmp.updateBy = this.updateBy;
        input_InstTmp.lastUpdateBy = this.lastUpdateBy;
        input_InstTmp.updateDt = this.updateDt;
        input_InstTmp.attr_Tab_Valid_Cd = this.attr_Tab_Valid_Cd;

        return input_InstTmp;
    }

    copyFrom(input_InstTmp: Input_Inst): void {
        this.input_Inst_Id = input_InstTmp.input_Inst_Id;
        this.dxMp_Id = input_InstTmp.dxMp_Id;
        this.nm = input_InstTmp.nm;
        this.description = input_InstTmp.description;
        this.ver = input_InstTmp.ver;
        this.valid_Cd = input_InstTmp.valid_Cd;
        this.persistFlg = input_InstTmp.persistFlg;
        this.updateBy = input_InstTmp.updateBy;
        this.lastUpdateBy = input_InstTmp.lastUpdateBy;
        this.updateDt = input_InstTmp.updateDt;
        this.attr_Tab_Valid_Cd = input_InstTmp.attr_Tab_Valid_Cd;
    }

    compare(input_InstTmp: Input_Inst): string {
        let input_InstString: string = this.toString(false);
        let input_InstTmpString: string = input_InstTmp.toString(false);

        if (input_InstString != input_InstTmpString) {
            return input_InstString + ', ' + input_InstTmpString;
        }

        return '';
    }

    toString(isNotCompare: boolean = true): string {
        let str:string= "Input_Inst [  input_Inst_Id=" + this.input_Inst_Id + ", dxMp_Id=" + this.dxMp_Id + ", nm=" + this.nm +
            ", description=" + this.description + ", ver=" + this.ver + ", valid_Cd=" + this.valid_Cd +
            ", persistFlg=" + this.persistFlg + ", updateBy=" + this.updateBy + 
            ", updateDt=" + this.updateDt + ", attr_Tab_Valid_Cd=" + this.attr_Tab_Valid_Cd + "]";
    
            if (isNotCompare) {
                 str+=", lastUpdateBy=" + this.lastUpdateBy; 
                
                
            }
    
            str += ']';
    
            return str;
        }
    }
    